<template>
    <table class="table table-responsive d-sm-table table-bordered tabs-elev-table mb-0 text-sm">
        <thead class="bg-primary-lighter text-white">
        <tr>
            <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0">{{ $t('Dato') }}</th>
            <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0">{{ $t('Type') }}</th>
            <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0">{{ $t('Forfallsdato') }}</th>
            <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0">{{ $t('Beløp') }}</th>
            <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0">{{ $t('Status') }}</th>
            <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0 text-center">{{ $t('Valg') }}</th>
        </tr>
        </thead>
        <tbody>
            <Invoice v-for="invoice in invoices" :invoice="invoice" :key="invoice.id" :isApp="isApp" :hashedKey="hashedKey"></Invoice>
        </tbody>
    </table>
</template>

<script setup>
import { computed } from 'vue'
import Store from '../../state/payableInvoiceStore'
import Invoice from './Invoice'

const props = defineProps(['isApp', 'hashedKey'])

const invoices = computed(() => Store.getInvoiceHistory())

</script>